import styled from "@emotion/styled";
import { fontAngkor, fontFredoka } from "@product/scmp-sdk";

import { BaseImage } from "scmp-app/components/common/base-image";
import { EntityLink } from "scmp-app/components/entity-link";
import { OffsetContainer } from "scmp-app/components/posties/offset-container";

export const StyledImage = styled(BaseImage)`
  border-radius: 12px;
  ${props => props.theme.breakpoints.up("tablet")} {
    border-radius: 20px;
  }
`;

export const StyledOffsetContainer = styled(OffsetContainer)`
  inline-size: 100%;
  margin-block-end: 4.2px;
  margin-inline-start: 4.2px;
  ${props => props.theme.breakpoints.up("desktop")} {
    margin-block-end: 11px;
    margin-inline-start: 11px;
  }

  picture {
    position: relative;
    inset-block-start: 4.33px;
    inset-inline-end: 4.33px;

    inline-size: 100%;
    block-size: 100%;

    border-radius: 20px;

    aspect-ratio: 323/187;

    ${props => props.theme.breakpoints.up("tablet")} {
      inset-block-start: 6.08px;
      inset-inline-end: 6.51px;
      aspect-ratio: 511/279;
    }
    ${props => props.theme.breakpoints.up("desktop")} {
      inset-block-start: 7.78px;
      inset-inline-end: 6.03px;
      aspect-ratio: 671/357;
    }
    ${props => props.theme.breakpoints.up("largeDesktop")} {
      inset-block-start: 11px;
      inset-inline-end: 11.69px;
      aspect-ratio: 898/477;
    }
  }
`;

export const LinkContainer = styled.div`
  :not(:empty, :last-child) {
    margin-block-end: 4px;
  }

  > :not(:first-child) {
    display: none;
  }
`;

export const Header = styled.div`
  margin-block-end: 4px;

  color: #1b4191;
  font-weight: 400;
  font-size: 36px;
  font-family: ${fontAngkor};
  font-family: Angkor;
  line-height: 40px;
  letter-spacing: -1.08px;
  text-align: center;
  ${props => props.theme.breakpoints.up("tablet")} {
    margin-block-end: 12px;

    letter-spacing: -1.92px;
    text-align: start;
  }

  ${props => props.theme.breakpoints.up("desktop")} {
    font-size: 48px;
    line-height: 56px;
  }
`;
export const Button = styled.div`
  margin-block-start: 16px;

  text-align: center;
  ${props => props.theme.breakpoints.up("tablet")} {
    margin-block-start: 32px;

    text-align: start;
  }
`;
export type CoverProps = {
  $isLongLabel: boolean;
  $label: string;
};

export const Cover = styled.div<CoverProps>`
  position: relative;

  margin-block-start: ${props => (props.$label !== null && props.$label !== "" ? "32px" : "16px")};
`;

export const Content = styled.div`
  display: -webkit-box;

  margin-block-start: 16px;

  color: #333333;
  font-weight: 400;
  font-size: 20px;
  font-family: ${fontFredoka};
  line-height: 28px;
  text-align: center;
  ${props => props.theme.breakpoints.up("tablet")} {
    margin-block-start: 32px;

    font-size: 22px;
    line-height: 32px;
    letter-spacing: -0.22px;
    text-align: start;
  }
  ${props => props.theme.breakpoints.up("desktop")} {
    font-size: 24px;
    line-height: 36px;
    letter-spacing: -0.24px;
  }
`;
export const Date = styled.div`
  color: rgba(85, 85, 85, 1);
  font-weight: 400;
  font-size: 18px;
  font-family: ${fontFredoka};
  line-height: 24px;
  text-align: center;
  ${props => props.theme.breakpoints.up("tablet")} {
    text-align: start;
  }
  ${props => props.theme.breakpoints.up("desktop")} {
    font-size: 24px;
    line-height: 32px;
  }
`;
export const StyledEntityLink = styled(EntityLink)`
  inline-size: 100%;
`;

export const Container = styled.div`
  inline-size: 100%;
  max-inline-size: 518px;
  padding-inline: 25px;
  ${props => props.theme.breakpoints.up("desktop")} {
    max-inline-size: 680px;
  }
  ${props => props.theme.breakpoints.up("largeDesktop")} {
    max-inline-size: 910px;
  }
`;
